import { useState } from 'react'

import { MobileOperationSystem } from '@/enums/mobileOperationSystem'

export const useOSDetection = () => {
  const detectMobileOS = () => {
    const userAgent = navigator.userAgent || ''
    const platform = navigator.platform || ''
    const maxTouchPoints = navigator.maxTouchPoints || 0

    if (
      /iPad|iPhone|iPod/.test(userAgent) ||
      platform === 'iPhone' ||
      (platform === 'MacIntel' && maxTouchPoints > 1)
    ) {
      return MobileOperationSystem.IOS
    } else if (userAgent.match(/Android/i)) {
      return MobileOperationSystem.ANDROID
    } else {
      return MobileOperationSystem.UNKNOWN
    }
  }

  const detectedOS = detectMobileOS()
  const [mobileOS] = useState<MobileOperationSystem>(detectedOS)

  console.log('useOSDetection is ', mobileOS)
  return mobileOS
}
